import { Component, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass'],
})
export class FooterComponent implements OnInit {
  public version = environment.version;

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/common/footer/footer.component.ts